import * as React from "react";
import type { SVGProps } from "react";

const SvgDropdownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={5}
    viewBox="0 0 10 5"
    {...props}
  >
    <path fillRule="evenodd" d="M5 5 0 0h10z" />
  </svg>
);
export default SvgDropdownArrow;
